import { Injectable } from '@angular/core'

import { CanDeactivateAbstractComponent } from '../components/can-deactivate-abstract.component'

@Injectable()
export class CanDeactivateGuard {
  canDeactivate(component: CanDeactivateAbstractComponent): boolean {
    if (!component.canDeactivate()) {
      return confirm(
        'Есть не сохранённые изменения. При переходе на другую страницу данные будут потеряны.'
      )
    }
    return true
  }
}
